import { render, staticRenderFns } from "./WidgetPageViewers.vue?vue&type=template&id=2fedebde&scoped=true"
import script from "./WidgetPageViewers.vue?vue&type=script&lang=js"
export * from "./WidgetPageViewers.vue?vue&type=script&lang=js"
import style0 from "./WidgetPageViewers.vue?vue&type=style&index=0&id=2fedebde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fedebde",
  null
  
)

export default component.exports